export const CLIENT_CONFIG = {
  cxa: {
    favicon: "/assets/favicon/cxa/cxa-favicon.ico",
    title: "Pacific Prime - Simplifying Insurance",
  },
  libertyxchange: {
    favicon: "/assets/favicon/liberty/lib-favicon.ico",
    title: "Liberty Xchange",
  },
};

const MAX_FILE_SIZE_IN_MB = 2;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_IN_MB * 1024 * 1024;
export const ACCEPT_FILES = ""; //accept all files
export const CLIENTS_EXCLUDED_FOR_PRIVACYLINK = ["dbsg"];

export const othersOverseasFields = [
  {
    "id": "providerName",
    "label": "Provider Name",
    "dataType": "String",
    "name": "providerName",
    "required": true,
    "disabled": false,
    "lookupList": ""
  }
]

export const othersFields = [
  {
    "id": "providerName",
    "label": "Provider Name",
    "dataType": "String",
    "name": "providerName",
    "required": true,
    "disabled": false,
    "lookupList": ""
  },
  {
    "id": "postalCode",
    "label": "Postal Code",
    "dataType": "String",
    "name": "postalCode",
    "required": true,
    "disabled": false,
    "lookupList": ""
  }
]


// WEBPACK FOOTER //
// ./components/constants.js